function statusClassName(status) {
  if (status === 'COMPLETE') {
    return 'status-pill weekly-practice-plan-pill-complete';
  }
  if (status === 'IN_PROGRESS') {
    return 'status-pill weekly-practice-plan-pill-progress';
  }
  return 'status-pill weekly-practice-plan-pill-not-started';
}

function statusLabel(status) {
  if (status === 'COMPLETE') {
    return 'Complete';
  }
  if (status === 'IN_PROGRESS') {
    return 'In progress';
  }
  return 'Not started';
}

function WeeklyPracticePlan({ plan, compact = false, title = 'Recommended weekly practice plan' }) {
  if (!plan) {
    return null;
  }

  return (
    <section className={`weekly-practice-plan ${compact ? 'weekly-practice-plan-compact' : ''}`}>
      <div className="weekly-practice-plan-header">
        <div>
          <p className="section-title">{title}</p>
          <p>{plan.headline}</p>
        </div>
        <span className={statusClassName(plan.status)}>{statusLabel(plan.status)}</span>
      </div>
      <p className="muted-text">{plan.detail}</p>
      <ul className="weekly-practice-plan-list">
        {(Array.isArray(plan.items) ? plan.items : []).map((item) => (
          <li key={item.key} className="weekly-practice-plan-item">
            <div className="weekly-practice-plan-item-header">
              <strong>{item.title}</strong>
              <span className={statusClassName(item.status)}>{statusLabel(item.status)}</span>
            </div>
            <p>{item.detail}</p>
            {Array.isArray(item.skill_labels) && item.skill_labels.length ? (
              <p className="muted-text">Focus areas: {item.skill_labels.join(', ')}</p>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default WeeklyPracticePlan;
